import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";

import { theme } from "../../theme/css/theme.css";
import { spacingVariants } from "../../utils/vanilla/spacingVariants";
import { alignVariants } from "../../utils/vanilla/alignVariants";
import { responsive } from "../../utils/responsive";

export const marqueeStyle = style({
  // Keep
});

export const marqueeContainerStyle = recipe({
  base: {
    position: "relative",
    display: "flex",
    overflow: "hidden",
    width: `calc(100% - ${theme.spacings.m})`,
    userSelect: "none",
    margin: `0 auto`,
    maxWidth: rem(1360),
    maskImage: `linear-gradient(to right, transparent, black 20px, black calc(100% - ${theme.spacings.l}), transparent)`,
    ...responsive({
      s: {
        width: `calc(100% - ${theme.spacings.xl})`,
        maskImage: `linear-gradient(to right, transparent, black 20px, black calc(100% - ${theme.spacings.l}), transparent)`,
      },
      m: {
        width: `calc(100% - ${theme.spacings.xxl})`,
        maskImage: `linear-gradient(to right, transparent, black 20px, black calc(100% - ${theme.spacings.xl}), transparent)`,
      },
    }),
  },
  variants: {
    gap: spacingVariants("gap"),
    align: alignVariants("alignItems"),
  },
});

export const marqueeContentStyle = recipe({
  base: {
    display: "flex",
    flexShrink: 0,
    alignItems: "center",
    gap: theme.spacings.xl,
  },
  variants: {
    gap: spacingVariants("gap"),
    align: alignVariants("alignItems"),
  },
});

export const marqueeAnimationStyle = recipe({
  base: {
    display: "flex",
    flexShrink: 0,
  },
  variants: {
    align: alignVariants("alignItems"),
    gap: spacingVariants("gap"),
  },
});
